import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/esm/Card'
import Controllers from '../../Api/Controllers'
import Slider from "react-slick";
import Helpers from '../../Components/Helpers/Helpers';
import ReactPlaceholder from 'react-placeholder/lib'
import Button from 'react-bootstrap/Button'
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import { useHistory } from 'react-router-dom'
import Input from '../../Components/Form/Input';
import FormCustom from '../../Components/Form/FormCustom';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import AppLayoutPublic from '../Layout/LayoutPublic';
import './EcommercePremium.scss';

function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        />
    );
}

const EcommercePublic = _ => {
    const { idCustomers } = useParams();
    const [readyAll, setReadyAll] = useState(false);
    const [clasifications, setClasifications] = useState([])
    const [readyProducts, setReadyProducts] = useState(false)
    const [clasificationSelected, setClasificationSelected] = useState('')
    const [productsByClasification, setProductsByClasification] = useState([])

    const [customersSelected, setCustomersSelected] = useState({})

    const [showCart, setShowCart] = useState(false)

    const history = useHistory()

    const [imagesBanner, setImagesBanner] = useState([])
    const [search, setSearch] = useState('');
    const [searched, setSearched] = useState('');
    const [firstLoad, setFirstLoad] = useState(false);

    useEffect(() => {
        async function validateData() {
            let getId = localStorage.getItem('id_customers_sale_public')
            if (!getId) {
                const generateIdPublico = await Controllers.ecommerce_publico.cart_customers_insert_publico({
                    p_id_customers: idCustomers
                });

                localStorage.setItem('id_customers_sale_public', generateIdPublico.data.id)
                getId = localStorage.getItem('id_customers_sale_public')
            }

            const getCartCustomers = await Controllers.ecommerce_publico.get_cart_customers_ecommerce_publico({
                p_id_customers: idCustomers,
                p_id_customers_sale_public: getId
            })

            if (getCartCustomers.response !== 'success') {
                localStorage.removeItem('id_customers_sale_public')
                window.location.reload();
            }

            setCustomersSelected(getCartCustomers.data)
            setFirstLoad(true);
        }

        validateData();
    }, [idCustomers])

    useEffect(() => {
        if (!readyAll && firstLoad) {
            Promise.all([
                Controllers.ecommerce_publico.get_clasification_ecommerce_publico({
                    p_id_customers: idCustomers
                }),
                Controllers.ecommerce_publico.get_text_id({ p_id_text: 3 })
            ]).then(([
                resClasification, resText
            ]) => {
                setClasifications(resClasification.data)
                setImagesBanner(resText.data)

                if (resClasification.data.length > 0) {
                    setClasificationSelected(resClasification.data[0].id_clasification)
                } else {
                    setReadyProducts(true)
                }

                setReadyAll(true);
            })
        }
    }, [readyAll, idCustomers, firstLoad])

    useEffect(() => {
        if (clasificationSelected && !readyProducts && firstLoad) {
            setReadyProducts(false)
            Controllers.ecommerce_publico.get_product_by_customers_ecommerce_publico({
                p_id_clasification: clasificationSelected,
                p_id_customers: idCustomers
            }).then(res => {
                setProductsByClasification(res.data)
                setReadyProducts(true)
            })
        }
    }, [clasificationSelected, readyProducts, idCustomers, firstLoad])

    const products = useMemo(() => <ReactPlaceholder ready={readyProducts} showLoadingAnimation rows={25}>
        <Card className="shop-products-panel">
            <Card.Body className="pb-4" id="carousel_ecommerce">
                <div className="shop-section-heading"><h3>Productos seleccionados</h3><span>Bienestar y oportunidad en una sola compra</span></div>
                {searched !== '' && <div>
                    <small>Resultados Encontrados: <strong>{productsByClasification.length} Productos</strong></small>
                </div>}
                <Slider {...{
                    dots: false,
                    arrows: true,
                    infinite: false,
                    speed: 500,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    /* autoplay: true,
                    autoplaySpeed: 3000, */
                    nextArrow: <SampleNextArrow />,
                    prevArrow: <SampleNextArrow />,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                }}>
                    {React.Children.toArray([
                        ...productsByClasification,
                    ].map(r => {
                        return <div className={''}>
                            <div className="shop-product-wrap">
                                <div className="shop-product-card">
                                    <div className="shop-product-image">
                                        <img src={Helpers.config.resourcesUrl({ url: r.file_photo })} alt={r.description_store_product} />
                                    </div>
                                    <div className="shop-product-info">
                                        <div className="shop-product-name">{r.description_store_product}</div>
                                        <div className="shop-product-price">$ {r.price_product}</div>
                                        <div className="shop-product-meta"><span>{r.point_product} puntos</span><span>VN {r.value_business_product}</span></div>
                                            <Button className="shop-add-button" onClick={_ => {
                                                Controllers.ecommerce_publico.cart_det_insert_update_ecommerce_publico({
                                                    p_id_customers: idCustomers,
                                                    p_id_customers_sale_public: customersSelected.id_customers_sale_public,
                                                    p_id_product: r.id_product,
                                                    p_qty: 1,
                                                    p_price: r.price_product,
                                                    p_lot: '',
                                                    p_point: r.point_product,
                                                    p_value_business: r.value_business_product,
                                                }).then(_ => {
                                                    setShowCart(true)
                                                })
                                            }}>
                                                <i className="fa fa-shopping-cart mr-2"></i> Agregar al carrito
                                            </Button>
                                    </div>
                                </div>
                            </div>
                            <br /><br />
                        </div>
                    }))}
                </Slider>
            </Card.Body>
        </Card>
    </ReactPlaceholder>, [readyProducts, productsByClasification, searched, customersSelected, idCustomers])

    /* if (Helpers.date.get({ format: '%Y-%m-%d' }) >= '2023-12-01') {
        return ''
    } */

    return <>
        <AppLayoutPublic type="ecommerce_publico">
            <div className="form-row ecommerce-premium">
                <div className="col-12 mb-4">
                    <section className="shop-hero">
                        <span className="shop-eyebrow">System Devs · Marketplace</span>
                        <h2>Eleva tu bienestar.<br />Impulsa tu negocio.</h2>
                        <p>Descubre productos seleccionados para acompañar tu estilo de vida y hacer crecer tu comunidad.</p>
                        <div className="shop-benefits"><span className="shop-benefit"><i className="fa fa-shield-alt"></i> Compra protegida</span><span className="shop-benefit"><i className="fa fa-box-open"></i> Productos originales</span><span className="shop-benefit"><i className="fa fa-star"></i> Beneficios exclusivos</span></div>
                    </section>
                </div>
                <div className="col-12 mb-4">
                    <Card className="shop-toolbar">
                        <Card.Body>
                            <ReactPlaceholder ready={readyAll} showLoadingAnimation rows={1}>
                                <div className="d-flex flex-column flex-md-row justify-content-between">
                                    <div className="d-flex flex-column flex-md-row align-self-start">
                                        <div className='align-self-center'><span className="shop-client-label">Tu asesor</span><strong className="shop-client-name">{customersSelected.id_customers} · {customersSelected.full_name_customers}</strong></div>
                                    </div>
                                    <div>
                                        <Button className="shop-cart-button mt-3 mt-md-0" onClick={_ => {
                                            history.push(Helpers.config.convertUrl({ url: `/ecommerce-publico/${idCustomers}/carrito` }))
                                        }}>
                                            <i className="fa fa-shopping-cart mr-2"></i> Ir a Carrito
                                        </Button>
                                    </div>
                                </div>
                            </ReactPlaceholder>
                        </Card.Body>
                    </Card>
                </div>
                <div className="col-12">
                    <Card className="shop-search-panel">
                        <Card.Body>
                            <Slider {...{
                                infinite: true,
                                speed: 500,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                                autoplay: false,
                                autoplaySpeed: 3000
                            }}>
                                {React.Children.toArray(imagesBanner?.file_image_text?.map(b => <div className="d-flex justify-content-center" style={{
                                    outline: 'none',
                                }}>
                                    <img src={Helpers.config.resourcesUrl({ url: b })} alt="" className="img-fluid" style={{ maxHeight: 400, width: '90%', borderRadius: 10 }} />
                                </div>))}
                            </Slider>
                        </Card.Body>
                    </Card>
                </div>
                <div className="col-12 mt-4">
                    <Card>
                        <Card.Body>
                            <FormCustom viewSubmit={false} onSubmit={() => {
                                if (search.trim() === '') {
                                    Helpers.toast.construct({
                                        response: 'warning',
                                        message: 'Ingrese un producto a buscar',
                                        toast
                                    });
                                    setSearch('');
                                    return;
                                }

                                setSearched(search);
                                setReadyProducts(false)
                                Controllers.ecommerce_publico.search_product_by_customers_ecommerce_publico({
                                    p_search: search,
                                    p_id_customers: idCustomers
                                }).then(res => {
                                    setProductsByClasification(res.data)
                                    setReadyProducts(true)
                                })
                            }}>
                                <Input
                                    value={search}
                                    onChange={e => setSearch(e.currentTarget.value)}
                                    text="Buscar Producto"
                                    placeholder="Buscar Producto"
                                    style={{
                                        height: 40
                                    }}
                                    required
                                    append={[
                                        <Button type="submit">
                                            <i className='fa fa-search mr-2'></i>
                                            <span>Buscar</span>
                                        </Button>
                                    ]}
                                />
                            </FormCustom>
                            {searched !== '' && <div className='mt-3 d-flex'>
                                <small className='text-muted mr-2'>Producto Buscado:</small>
                                <div className='d-flex'>
                                    <div className='d-flex badge badge-secondary cur-pointer' onClick={() => {
                                        setSearched('');
                                        setSearch('');
                                    }}>
                                        <div className='mr-2 align-self-center'>{searched}</div>
                                        <div className='align-self-center'>
                                            <i className='fa fa-times'></i>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        </Card.Body>
                    </Card>
                </div>
                {searched === '' && <div className="col-12 mt-4">
                    <div className="shop-categories">
                        {React.Children.toArray(clasifications.map(c => <div className={'shop-category ' + (parseInt(c.id_clasification) === parseInt(clasificationSelected) ? 'active' : '')} onClick={_ => {
                            setClasificationSelected(c.id_clasification)
                            setReadyProducts(false)
                        }}>
                            {c.name_clasification}
                        </div>))}
                    </div>
                </div>}
                <div className="col-12 mt-4">
                    {products}
                </div>
            </div>
            <SweetAlert
                icon="shopping"
                show={showCart}
                showCancelButton
                title={<>Producto agregado al carrito</>}
                subtitle={<>¿Desea pagar ahora?</>}
                confirmButtonText="¡Sí, Pagar!"
                cancelButtonText="¡Seguir Comprando!"
                onCancel={() => setShowCart(false)}
                onConfirm={() => {
                    history.push(Helpers.config.convertUrl({ url: `/ecommerce-publico/${idCustomers}/carrito` }))
                }}
            />
        </AppLayoutPublic>
    </>
}

export default EcommercePublic
